/* =====================================================================
   Aztral TCG — sell-page item list
   Adds/removes item rows in the contact form, renumbers them so the
   emailed fields stay sequential (Item 1, Item 2, ...), and shows the
   grade field only for slabs. Pure DOM, no dependencies. Defensive: every
   lookup is guarded and the first row works server-side without this file.
   ===================================================================== */
(function () {
  'use strict';

  function init() {
    var form = document.getElementById('AztralSellForm');
    if (!form) return;

    var list = form.querySelector('[data-az-items]');
    var tpl = document.getElementById('az-sell-row-tpl');
    var addBtn = form.querySelector('[data-az-add-item]');
    if (!list || !tpl || !addBtn) return;

    var MAX_ROWS = 30;

    function rows() {
      return Array.prototype.slice.call(list.querySelectorAll('[data-az-row]'));
    }

    function renumber() {
      var all = rows();
      all.forEach(function (row, idx) {
        var n = idx + 1;
        row.setAttribute('data-index', String(n));
        var numEl = row.querySelector('.az-item-num');
        if (numEl) numEl.textContent = 'Item ' + n;
        row.querySelectorAll('[data-field]').forEach(function (field) {
          var key = field.getAttribute('data-field');
          if (key) field.setAttribute('name', 'contact[Item ' + n + ' - ' + key + ']');
        });
      });
      var removeBtns = list.querySelectorAll('[data-az-remove]');
      var onlyOne = all.length <= 1;
      removeBtns.forEach(function (btn) {
        btn.disabled = onlyOne;
        btn.style.visibility = onlyOne ? 'hidden' : 'visible';
      });
      addBtn.disabled = all.length >= MAX_ROWS;
    }

    function toggleGrade(row) {
      if (!row) return;
      var typeSel = row.querySelector('[data-az-type]');
      var grade = row.querySelector('[data-az-grade]');
      if (!typeSel || !grade) return;
      var isSlab = /slab/i.test(typeSel.value || '');
      grade.hidden = !isSlab;
      var input = grade.querySelector('input');
      if (input && !isSlab) input.value = '';
    }

    function wire(row) {
      if (!row) return;
      var typeSel = row.querySelector('[data-az-type]');
      if (typeSel) {
        typeSel.addEventListener('change', function () { toggleGrade(row); });
        toggleGrade(row);
      }
      var removeBtn = row.querySelector('[data-az-remove]');
      if (removeBtn) {
        removeBtn.addEventListener('click', function () {
          if (rows().length <= 1) return;
          row.parentNode.removeChild(row);
          renumber();
        });
      }
    }

    function addRow() {
      if (rows().length >= MAX_ROWS) return;
      var n = rows().length + 1;
      var html = (tpl.innerHTML || '').replace(/__i__/g, String(n));
      var holder = document.createElement('div');
      holder.innerHTML = html.trim();
      var row = holder.firstElementChild;
      if (!row) return;
      list.appendChild(row);
      wire(row);
      renumber();
      var firstInput = row.querySelector('input, select');
      if (firstInput) firstInput.focus();
    }

    addBtn.addEventListener('click', addRow);
    rows().forEach(wire);
    renumber();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
